import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import { IAPI_COM001_Request, IAPI_COM001_Response } from "../../../type/apiType";
import {
  IAPI_COM002_Request,
  IAPI_COM002_Response,
} from "../../../type/apiType";

/**
 * フォーム認証（WEB）API
 * @return httpLogin
 */
const httpLogin = async (param: IAPI_COM001_Request): Promise<IAPI_COM001_Response> => {
  let res = await http.post(ApiUrl.API_COM001, {
    ...param,
  });

  return res.data;
};

/**
 * フォーム認証（WAM）API
 * @return httpWamLogin
 */
const httpWamLogin = async (
  param: IAPI_COM002_Request
): Promise<IAPI_COM002_Response> => {
  let res = await http.post(ApiUrl.API_COM002, {
    ...param,
  });

  return res.data;
};

export { httpLogin, httpWamLogin };
